<template>
  <g>
    <g clip-path="url(#clip0_15_583)">
      <path
        d="M19.04 3.00018H5.04001C3.94001 3.00018 3.04001 3.90018 3.04001 5.00018V19.0002C3.04001 20.1002 3.94001 21.0002 5.04001 21.0002H19.04C20.14 21.0002 21.04 20.1002 21.04 19.0002V5.00018C21.04 3.90018 20.14 3.00018 19.04 3.00018ZM14.04 17.0002C13.49 17.0002 13.04 16.5502 13.04 16.0002V13.0002H10.04C9.49001 13.0002 9.04001 12.5502 9.04001 12.0002V8.00018C9.04001 7.45018 9.49001 7.00018 10.04 7.00018C10.59 7.00018 11.04 7.45018 11.04 8.00018V11.0002H13.04V8.00018C13.04 7.45018 13.49 7.00018 14.04 7.00018C14.59 7.00018 15.04 7.45018 15.04 8.00018V16.0002C15.04 16.5502 14.59 17.0002 14.04 17.0002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_583">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
